import LocalizationStore from '../Stores/LocalizationStore'
import { CellInfo } from 'react-table'
import { Button } from 'react-bootstrap'
import * as React from 'react'
import * as FontAwesome from 'react-icons/lib/fa'
import ActionsLocalService from '../Services/ActionsLocalService'

export default class Setting {
    constructor(key: string, value: string) {
        this.key = key
        this.value = value
    }

    key: string
    value: string
}

const ls = LocalizationStore.getInstance()

export function getTableSettingsColums(): any {
    let actionsLocalService = ActionsLocalService.getInstance()
    return [
        {
            Header: ls.t('Key'),
            maxWidth: 500,
            minWidth: 100,
            accessor: 'key',
            filterable: true,
            sortable: false,
        },
        {
            Header: ls.t('Value'),
            accessor: 'value',
            maxWidth: 500,
            minWidth: 100,
            filterable: true,
            sortable: false,
        },
        {
            Header: ls!.t(''),
            maxWidth: 40,
            minWidth: 40,
            accessor: '',
            filterable: false,
            sortable: false,
            Cell: (cellInfo: CellInfo) => (
                <Button
                    className="btn-success"
                    onClick={() => {
                        var input = document.createElement('textarea');
                        input.innerHTML = cellInfo.row.value;
                        document.body.appendChild(input);
                        input.select();
                        var result = document.execCommand('copy');
                        document.body.removeChild(input);
                        return result;
                    }}
                >
                    <FontAwesome.FaCopy
                        color="white"
                        size={16}
                    />
                </Button>
            )
        },
        {
            Header: ls!.t(''),
            maxWidth: 40,
            minWidth: 40,
            accessor: '',
            filterable: false,
            sortable: false,
            Cell: (cellInfo: CellInfo) => (
                <Button
                    className="btn-danger"
                    onClick={() => {
                        actionsLocalService.setSettingToDelete(cellInfo.row.key)
                    }}
                >
                    <FontAwesome.FaTrashO
                        color="white"
                        size={16}
                    />
                </Button>
            )
        }
    ]
}

export function getSettingUpdateFormSchema(): any {
    return {
        'title': ls.t!('Create or update setting'),
        'type': 'object',
        'required': [
            'key',
            'value'
        ],
        'properties': {
            'key': {
                'title': ls.t!('Key'),
                'type': 'string'
            },
            'value': {
                'title': ls.t!('Value'),
                'type': 'string'
            }
        }
    }
}

export const UISettingUpdateFormSchema = {
    'termCountMonthsPrefill': {
        'ui:widget': 'textarea'
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/Setting.tsx